import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'
import ContactForm from '../components/ContactForm/ContactForm'

const Terms = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="laptop-on-table.png"
                  alt="People working on laptop together"
                />
              </div>
              <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-32">
                <h1 className="text-4xl tracking-tight font-extralight sm:text-5xl lg:text-6xl text-blue-dark">
                  Terms of Service
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8 text-grey">
            <h3 className="pb-8 text-xl">Effective Date: September 1, 2021</h3>

            <h3 className="pb-8 text-xl">
              Important Note Regarding Website Content
            </h3>
            <p>
              The information and content on this website is for your general
              educational information only. The content cannot, and is not
              intended to, replace the relationship that you have with your
              healthcare professionals. The content on this website should not
              be considered medical advice and is not intended as medical
              advice. If you are experiencing a medical emergency, you should
              not rely on any information on this website and should seek
              appropriate emergency medical assistance, such as calling “911”.
              You should always talk to your healthcare professionals for
              diagnosis and treatment, including information regarding which
              drugs or treatment may be appropriate for you. None of the content
              on this website represents or warrants that any particular drug or
              treatment is safe, appropriate or effective for you. Health
              information changes quickly, and you should always confirm
              information with your healthcare professionals. The content may
              include information regarding therapeutic and generic alternatives
              for certain prescription drugs, and may describe uses for products
              or therapies that have not been approved by the Food and Drug
              Administration. This content is for informational purposes only.
              It is not medical advice and does not replace consultation with a
              doctor, pharmacist or other healthcare professional.
            </p>

            <h3 className="py-8 text-xl">Agreement and Terms</h3>
            <p className="pb-6">
              Please read these Terms of Service (the “Terms”) fully and
              carefully before using www.evryhealth.com (the “Site”) and the
              services, content, features, or applications (including without
              limitation, the Evry mobile application) offered by Evry (together
              with the Site, the “Services”). These Terms constitute a legally
              binding agreement between you, the person using this website, and
              Evry Healthcare, Inc., a Globe Life Company, its parents,
              subsidiaries, and affiliates (collectively, “Evry,” “Evry Health,”
              “we,” “us” and “our”). If you are helping another person use this
              website, these Terms constitute a legally binding agreement
              between both the helper and the person being helped and Evry.
              These Terms include the provisions in this document, as well as
              those in the Privacy Policy.
            </p>

            <p className="pb-6">
              BY USING OR OTHERWISE ACCESSING THE SERVICES, REGARDLESS OF
              WHETHER YOU REGISTER OR CREATE AN ACCOUNT, YOU AGREE TO THE
              MOST-RECENT TERMS AS WELL AS THE INFORMATION DISCLOSED IN OUR
              PRIVACY POLICY. WE MAY CHANGE THESE TERMS AT ANY TIME, AND SUCH
              NOTIFICATION OF MATERIAL CHANGES WILL BE POSTED ON THIS OR A
              SIMILAR PAGE OF THIS WEBSITE, EMAILED TO YOU, AND/OR DELIVERED BY
              OTHER MEANS. IT IS YOUR RESPONSIBILITY TO REVIEW THESE TERMS EACH
              TIME YOU USE THIS WEBSITE. YOU CONSENT TO ANY CHANGES TO OUR TERMS
              BY CONTINUING TO USE THIS WEBSITE.
            </p>

            <p>
              By using the Services, you acknowledge and agree that any activity
              on this website is subject to monitoring by Evry at any time, and
              that Evry may use the results of such monitoring without
              limitation, subject to applicable law.
            </p>
            <p>
              If you enter into any other agreement with Evry, for example
              regarding health plan coverage, then these Terms are in addition
              to the terms of such other agreement. Neither entering into this
              agreement, nor visiting this website, nor any of these Terms,
              guarantees that you are eligible to receive coverage under any
              plan offered through this website or otherwise.
            </p>

            <h3 className="py-6 text-xl">Restrictions on Use of Services</h3>
            <p className="pb-6">You agree:</p>
            <ul className="ml-8 list-disc">
              <li>
                Not to use the Services in any way not explicitly permitted by
                these Terms, or the text of the website itself;
              </li>
              <li>
                Not to infringe or violate the intellectual property rights of
                Evry;
              </li>
              <li>
                Not to copy, modify, reproduce, translate, broadcast, transmit,
                upload, perform, distribute, display, license, sell, or create
                derivative works involving the Service without the prior written
                consent of Evry, except you may download or print a reasonable
                number of copies of allowed content, such as legal notices
                including schedule of benefits and HIPAA notices, for your
                personal use, provided that you reproduce all proprietary
                copyright and trademark notices;
              </li>
              <li>
                Not to “Crawl” or “Scrape” any page, data, or component of the
                Services through the use of automated or manual means;
              </li>
              <li>
                Not to misrepresent your identity or provide us with any false
                information at registration or any other information-collection
                portion of the Services;
              </li>
              <li>
                Not to take any action intended to interfere with the operation
                of the Services;
              </li>
              <li>
                Not to decompile, reverse engineer, or otherwise attempt to
                obtain the source code or underlying information related to the
                Services;
              </li>
              <li>
                Not to access or attempt to access any portion of the Services
                to which you have not been explicitly granted access;
              </li>
              <li>
                Not to share any password assigned to or created by you with any
                third-parties or use any password granted to or created by a
                third-party;
              </li>
              <li>
                Not to directly or indirectly authorize anyone else to take
                actions prohibited in this section;
              </li>
              <li>
                To comply with all applicable laws and regulations while using
                the Services. You represent and warrant that you are at least 13
                years of age, and that if you are between 13 and 18 years of age
                a parent and/or guardian agrees to these Terms of Use on your
                behalf.
              </li>
            </ul>

            <h3 className="py-6 text-xl">Messages, Comments, or Content</h3>
            <p className="pb-4">
              Certain portions of the Services may be configured in such a way
              as to permit users to submit messages, comments, documents, or
              other content. You agree not to submit any content that:
            </p>
            <ul className="pb-6 ml-8 list-disc">
              <li>
                Is profane, libelous, defamatory, obscene, indecent, lewd,
                harassing, pornographic, harmful, threatening, invasive of
                privacy or publicity rights, abusive, inflammatory, or otherwise
                objectionable;
              </li>
              <li>
                The transmission of which could violate, or facilitate the
                violation of, any applicable law, regulation, or intellectual
                property rights.
              </li>
            </ul>
            <p className="pb-6">
              You are solely responsible for the content of submissions and Evry
              assumes no responsibility or liability for any content submitted
              by you or any other user of the Services. Evry may, but is not
              obligated to, restrict or remove any and all content from a
              message that we determine in our sole discretion violates these
              Terms or is otherwise harmful to us, our customers, or any
              third-party. We reserve the right to remove the content you
              provide at any time, but you understand that we may preserve and
              access a backup-copy, and we may disclose the content if required
              to do so by law or in a good faith belief that such access,
              preservation, or disclosure is required by law or in the best
              interests of Evry.
            </p>
            <p className="pb-6">
              Any content you submit is for non-commercial use only. You
              understand and acknowledge that you have no expectation of privacy
              with regard to any content you submit. Never assume that you are
              anonymous and cannot be identified during your utilization of the
              Services.
            </p>
            <p>
              If you do post content or submit material, and unless we indicate
              otherwise, you grant Evry a nonexclusive, royalty-free, perpetual,
              irrevocable, and fully sublicensable right to use, reproduce,
              modify, adapt, publish, translate, create derivative works from,
              distribute, and display such content throughout the world in any
              media. You grant Evry and any of its sublicensees the right to use
              the name that you submit in connection with such content, if they
              choose. You represent and warrant that you own or otherwise
              control all of the rights to the content that you post; that the
              content is accurate; that use of the content you supply does not
              violate these Terms and Conditions and will not cause injury to
              any person or entity; and that you will indemnify Evry for all
              claims resulting from content you supply.
            </p>

            <h3 className="py-6 text-xl">Changes to the Services</h3>
            <p>
              We may change, add or remove some or all of the content or
              capabilities of the Services at any time. In addition, please note
              that although our goal is to provide accurate information, certain
              features that may be offered through the Services, such as
              participating healthcare providers, pricing information or other
              Content, may not be accurate or up-to-date. In addition, please
              note that features of any plan or plans described in this website
              may change over time as permitted by law, including benefit
              levels, items included in any formulary, pricing or lists of
              participating providers or other associated vendors.
            </p>

            <h3 className="py-6 text-xl">
              Links to External Websites or Services
            </h3>
            <p>
              While utilizing the Services you may click on a link to websites
              or other services and leave the Services. We provide links to
              websites or other services that may contain information or
              services that may be valuable or interesting to you. We do not
              endorse, and are not responsible for, the content, accuracy, or
              security of linked resources operated by third-parties or for any
              of your dealings with third-parties. You are solely responsible
              for your dealings with third-parties.
            </p>

            <h3 className="py-6 text-xl">
              What if I want to stop using the Services?
            </h3>
            <p>
              You&#39;re free to stop using the Services at any time, by
              contacting us at 1-855-579-3879; please refer to our Privacy
              Policy. Account termination may result in destruction of any
              Content associated with your account, so keep that in mind before
              you decide to terminate your account. Evry is also free to
              terminate (or suspend access to) your use of the Services, for any
              reason in our discretion, including your breach of these Terms.
              Evry has the sole right to decide whether you are in violation of
              any of the restrictions set forth in these Terms. Provisions that,
              by their nature, should survive termination of these Terms shall
              survive termination.
            </p>

            <h3 className="py-6 text-xl">
              What is our mobile text message policy?
            </h3>
            <p className="pb-6">
              Consistent with our Privacy Policy, some of our Services may allow
              you to receive SMS (text) notifications from us. To the extent
              your SMS notification settings permit us to send SMS messages to
              your mobile phone, the following terms apply:
            </p>
            <p className="pb-6">
              In addition to any fee of which you are notified, your mobile
              provider&#39;s standard messaging rates apply to our confirmation
              SMS and all subsequent SMS correspondence. You may choose to
              receive Evry mobile SMS alerts by signing up. Message and data
              rates may apply, according to your individual rate plan provided
              by your wireless carrier. Please consult your mobile service
              carrier&#39;s pricing plan to determine the charges for browsing
              data and sending and receiving SMS messages. Under no
              circumstances will Evry, or its affiliates be responsible for any
              SMS messaging or wireless charges incurred by you or by a person
              that has access to your wireless device or telephone number. If
              your carrier does not permit SMS messages, you may not receive the
              Evry SMS alerts. Pre-paid phones or calling plans may not be
              supported. You may receive a bounceback message for every message
              you send to us.
            </p>
            <p>
              We will not be liable for any delays in the receipt of any SMS
              messages, as delivery is subject to effective transmission from
              your network operator. SMS message services are provided on an AS
              IS basis. Data obtained from you in connection with this SMS
              service may include your cell phone number, your provider&#39;s
              name, and the date, time, and content of your messages. We may use
              this information to contact you and to provide the Services you
              request from us. We will never share this information with a
              third-party, except as expressly provided in our Privacy Policy.
            </p>

            <h3 className="py-6 text-xl">Warranty Disclaimer</h3>
            <p className="pb-6">
              Neither Evry nor its licensors or suppliers make any
              representations or warranties concerning any content contained in
              or accessed through the Services, and we will not be responsible
              or liable for the accuracy, copyright compliance, legality, or
              decency of material contained in or accessed through the Services.
              We (and our licensors and suppliers) make no representations or
              warranties regarding suggestions or recommendations of services or
              products offered or purchased through the Services.
            </p>
            <p className="pb-6">
              THE SERVICES AND CONTENT ARE PROVIDED BY EVRY (AND ITS LICENSORS
              AND SUPPLIERS) ON AN “AS-IS”,”AS AVAILABLE” BASIS, WITHOUT
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING,
              WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
              FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR THAT USE OF THE
              SITE WILL BE UNINTERRUPTED OR ERROR-FREE.
            </p>
            <p className="pb-6">
              EVRY MAKES NO WARRANTY AS TO THE ACCURACY, COMPLETENESS, OR
              RELIABILITY OF ANY CONTENT AVAILABLE THROUGH THE SERVICES. WITHOUT
              LIMITING THE FOREGOING, EVRY DOES NOT REPRESENT OR WARRANT THAT
              ANY INFORMATION REGARDING PARTICULAR PLAN BENEFITS OR SCOPE OF
              COVERAGE IS ACCURATE OR COMPLETE. EVRY MAKES NO REPRESENTATIONS OR
              WARRANTIES THAT USE OF THE SERVICES WILL BE UNINTERRUPTED OR
              ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVICES
              OR THE TECHNOLOGY THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR
              OTHER HARMFUL COMPONENTS. YOU ARE RESPONSIBLE FOR TAKING ALL
              PRECAUTIONS NECESSARY TO ENSURE THAT ANY CONTENT YOU MAY OBTAIN
              FROM THIS WEBSITE IS FREE OF VIRUSES AND ANY OTHER POTENTIALLY
              DESTRUCTIVE COMPUTER CODE.
            </p>
            <p>
              Some states do not allow limitations on implied warranties, so one
              or more of the above limitations may not apply to you. Check your
              local laws for any restrictions or limitations regarding the
              exclusion of implied warranties.
            </p>

            <h3 className="py-6 text-xl">Limitation of Liability</h3>
            <p>
              TO THE FULLEST EXTENT ALLOWED BY APPLICABLE LAW, IN NO EVENT SHALL
              WE, NOR OUR DIRECTORS, EMPLOYEES, AGENTS, PARTNERS, SUPPLIERS,
              LICENSORS OR CONTENT PROVIDERS, BE LIABLE UNDER CONTRACT, TORT,
              STRICT LIABILITY, NEGLIGENCE OR ANY OTHER LEGAL OR EQUITABLE
              THEORY WITH RESPECT TO THE SERVICES (I) FOR ANY LOST PROFITS, DATA
              LOSS, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR
              SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, COMPENSATORY OR
              CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER, SUBSTITUTE GOODS OR
              SERVICES (HOWEVER ARISING), (II) FOR ANY BUGS, VIRUSES, TROJAN
              HORSES, OR THE LIKE (REGARDLESS OF THE SOURCE OF ORIGINATION),
              (III) FOR ANY MATTER BEYOND OUR REASONABLE CONTROL OR (IV) FOR ANY
              DIRECT DAMAGES IN EXCESS OF (IN THE AGGREGATE) OF THE GREATER OF
              (A) FEES PAID TO US FOR THE PARTICULAR SERVICES DURING THE
              IMMEDIATELY PREVIOUS THREE (3) MONTH PERIOD OR (B) $100.00. SOME
              STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF CERTAIN
              DAMAGES, SO THE ABOVE LIMITATION AND EXCLUSIONS MAY NOT APPLY TO
              YOU.
            </p>

            <h3 className="py-6 text-xl">Indemnity</h3>
            <p>
              To the fullest extent allowed by applicable law, you shall defend,
              indemnify, and hold harmless Evry, our affiliates and each of our
              and their respective employees, contractors, directors, suppliers,
              partners and representatives from all liabilities, claims,
              damages, losses and expenses, including reasonable attorneys&#39;
              fees, that arise from or relate to your use or misuse of, or
              access to, the services and content we offer, violation of these
              Terms, or infringement by you, or any third-party using your
              identity in the services, of any intellectual property or other
              right of any person or entity. We reserve the right to assume the
              exclusive defense and control of any matter otherwise subject to
              indemnification by you, in which event you will assist and
              cooperate with us in asserting any available defenses. In the
              event of such a claim, suit, or action (“Claim”), we will attempt
              to provide notice of the Claim to the contact information we have
              on file (provided that failure to deliver such notice shall not
              eliminate or reduce your indemnification obligations hereunder).
            </p>

            <h3 className="py-6 text-xl">
              Governing Law, Statute of Limitations, and Arbitration
            </h3>
            <p className="pb-6">
              These Terms are governed by and will be construed under the laws
              of the State of Texas, without regard to the conflicts of laws
              provisions thereof.
            </p>
            <p className="pb-6">
              Any dispute arising from or relating to the subject matter of
              these Terms shall be finally settled in Dallas, Texas, in English,
              in accordance with the Streamlined Arbitration Rules and
              Procedures of Judicial Arbitration and Mediation Services, Inc.
              (“JAMS”) then in effect, by one commercial arbitrator with
              substantial experience in resolving intellectual property and
              commercial contract disputes, who shall be selected from the
              appropriate list of JAMS arbitrators in accordance with such
              Rules. Judgment upon the award rendered by such arbitrator may be
              entered in any court of competent jurisdiction. Notwithstanding
              the foregoing obligation to arbitrate disputes, each party shall
              have the right to pursue injunctive or other equitable relief at
              any time, from any court of competent jurisdiction. For all
              purposes of these Terms, the parties consent to exclusive
              jurisdiction and venue in the state or federal courts located in
              Dallas, Texas. Any arbitration under these Terms will take place
              on an individual basis: class arbitrations and class actions are
              not permitted. YOU UNDERSTAND AND AGREE THAT BY ENTERING INTO
              THESE TERMS, YOU AND EVRY ARE EACH WAIVING THE RIGHT TO TRIAL BY
              JURY OR TO PARTICIPATE IN A CLASS ACTION.
            </p>
            <p>
              Before seeking legal recourse for any harm you believe you have
              suffered arising from or related to your use of this website, you
              agree to inform us in writing and to give us 30 days to cure the
              harm before initiating any action. You must initiate any cause of
              action within one year after the claim has arisen, or you will be
              barred from pursuing any cause of action.
            </p>

            <h3 className="py-6 text-xl">Miscellaneous</h3>
            <p>
              You will be responsible for paying, withholding, filing, and
              reporting all taxes, duties, and other governmental assessments
              associated with your activity in connection with the Services,
              provided that Evry may, in its sole discretion, do any of the
              foregoing on your behalf or for itself as it sees fit. If any
              provision of these Terms is found to be unenforceable or invalid,
              that provision will be limited or eliminated, to the minimum
              extent necessary, so that these Terms shall otherwise remain in
              full force and effect and enforceable. You and Evry agree that
              these Terms are the complete and exclusive statement of the mutual
              understanding between you and Evry with respect to the Services,
              and that it supersedes and cancels all previous written and oral
              agreements, communications and other understandings relating to
              the subject matter of these Terms. Evry&#39;s failure to insist
              upon or enforce strict performance of any provision of these Terms
              shall not be construed as a waiver of any provision or right. The
              course of conduct between you and Evry shall not act to modify any
              provision of these Terms. You may not assign, delegate or transfer
              these Terms or your rights or obligations hereunder, or your
              Services account, in any way (by operation of law or otherwise)
              without Evry&#39;s prior written consent. Evry may assign its
              rights and duties hereunder to any third-party at any time without
              notice to you. We may deliver notice to you concerning these Terms
              by means of electronic mail, by a general notice on the website,
              or by written communication delivered by first-class U.S. mail to
              your address on record in our files.
            </p>

            <h3 className="py-6 text-xl">Contact Us</h3>
            <p>
              To contact us regarding these Terms or the operation of the
              Services itself, contact us at{' '}
              <a href="tel:18555793879" className="text-globeGreen">
                1-855-579-3879
              </a>
              .
            </p>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default Terms
